<app-stages [stages]="stages" currentStage="Umieszczenie reklamy">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class="col-12">
        <app-ad-placement-road-occupation-form
          [form]='form'>
        </app-ad-placement-road-occupation-form>
      </div>
    </div>
    <div class='form-actions'>
      <button
        [disabled]="pending()"
        (click)="onCancel()"
        type='button'
        class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
      </button>
      <button
        [disabled]="pending()"
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
  <br>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
